import { TimeTranslationKeys } from '../../api/models/TranslationKeys';
import { Backend } from '../../api/Backend';

export class DateUtil {
  /**
   *
   * @param {Date} a
   * @param {Date} b
   */
  static isSameDay(a: Date, b: Date) {
    return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  }

  /**
   * @note This mutates the existing date
   * @param {Date} date
   */
  static toStartOfDay(date: Date) {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  /**
   * @note This mutates the existing date
   * @param {Date} date
   */
  static toStartOfHour(date: Date) {
    date.setMinutes(0, 0, 0);
    return date;
  }

  /**
   * @note This mutates the existing date
   * @param {Date} date
   * @param {number} add
   */
  static addUTCDays(date: Date, add: number) {
    date.setUTCDate(date.getUTCDate() + add);
    return date;
  }

  /**
   * @note This mutates the existing date
   * @param {Date} date
   */
  static toStartOfUTCDay(date: Date) {
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  static getMonthTranslation(month: number, backend: Backend) {
    switch (month) {
      case 0:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_january);
      case 1:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_february);
      case 2:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_march);
      case 3:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_april);
      case 4:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_may);
      case 5:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_june);
      case 6:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_july);
      case 7:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_august);
      case 8:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_september);
      case 9:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_october);
      case 10:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_november);
      case 11:
        return backend.translations.forKey(TimeTranslationKeys.time_month_short_december);
      default:
        return '';
    }
  }

  static getYesterdayTodayTomorrowTranslation(daysDiff: number, backend: Backend) {
    switch (daysDiff) {
      case -1:
        return backend.translations.forKey(TimeTranslationKeys.time_yesterday);
      case 0:
        return backend.translations.forKey(TimeTranslationKeys.time_today);
      case 1:
        return backend.translations.forKey(TimeTranslationKeys.time_tomorrow);
      default:
        return '';
    }
  }

  /**
   * @note 0 is sunday, 1 monday
   * @param {number} dayNum
   * @param {Backend} backend
   * @returns {string|*}
   */
  static getShortDayTranslation(dayNum: number, backend: Backend): string {
    switch (dayNum) {
      case 0:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_sun);
      case 1:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_mon);
      case 2:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_tue);
      case 3:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_wed);
      case 4:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_thu);
      case 5:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_fri);
      case 6:
        return backend.translations.forKey(TimeTranslationKeys.time_day_short_sat);
      default:
        return '';
    }
  }

  /**
   * @note 0 is sunday, 1 monday
   * @param {number} dayNum
   * @param {Backend} backend
   * @returns {string|*}
   */
  static getDayTranslation(dayNum: number, backend: Backend): string {
    switch (dayNum) {
      case 0:
        return backend.translations.forKey(TimeTranslationKeys.time_day_sunday);
      case 1:
        return backend.translations.forKey(TimeTranslationKeys.time_day_monday);
      case 2:
        return backend.translations.forKey(TimeTranslationKeys.time_day_tuesday);
      case 3:
        return backend.translations.forKey(TimeTranslationKeys.time_day_wednesday);
      case 4:
        return backend.translations.forKey(TimeTranslationKeys.time_day_thursday);
      case 5:
        return backend.translations.forKey(TimeTranslationKeys.time_day_friday);
      case 6:
        return backend.translations.forKey(TimeTranslationKeys.time_day_saturday);
      default:
        return '';
    }
  }

  /**
   * @param {boolean} replay
   * @param {boolean} pastAndFuture
   * @returns {Date[]}
   */
  static getFilterDates(replay = false, pastAndFuture = false): Date[] {
    const res = [];

    let start = DateUtil.toStartOfDay(new Date());
    let dayAmount;
    if (replay) {
      dayAmount = 7;
    } else {
      dayAmount = 7; //todo remove magic numbers
    }

    if (pastAndFuture) {
      start = DateUtil.addUTCDays(start, replay ? 7 : -7);
      dayAmount = 14;
    }

    res.push(start);

    let itr = new Date(start);
    const dir = replay ? -1 : +1;
    for (let i = 0; i < dayAmount; i++) {
      itr = DateUtil.addUTCDays(itr, dir);
      res.push(new Date(itr));
    }

    return res;
  }
}
